import {BackendModule} from './../../../../modules/backend.module';
import {AuthService} from './../../../../services/auth';
import {Component} from '@angular/core';
import {NavController, AlertController, App} from 'ionic-angular';
import {SessionService} from './../../../../services/session';
import {BeautyFiltersService} from '../../../../services/beauty-filters';
import {BeautyClassPage} from '../../shared/beauty-class/beauty-class';
import {BeautyReviewPage} from '../../shared/beauty-review/beauty-review';

@Component({
  selector: 'page-my-beauty-classes',
  templateUrl: 'my-beauty-classes.html'
})
export class MyBeautyClassesPage {
  classPage = BeautyClassPage;
  showPast = false;

  // https://ionicframework.com/docs/v3/api/components/content/Content/#resizing-the-content
  // @ViewChild(Content) content: Content;


  constructor(
    public navCtrl: NavController,
    public sessionService: SessionService,
    public authService: AuthService,
    public filtersService: BeautyFiltersService,
    public backendModule: BackendModule,
    public app: App,
    public alertCtrl: AlertController
  ) {
    this.filtersService.myClassesType = 'current';
    setTimeout(() => {
      this.filtersService.myClassesType = 'reserved';

      this.seeMoreClasses();
      // this.content.resize();
    });
  }

  goToClass(classInfo) {
    this.navCtrl.push(this.classPage, {classInfo})
  }

  ionViewDidLoad() {
    window['page'] = 'MyBeautyClassesPage'; // for GA
  }

  seeMoreClasses() {
    if (this.filtersService.loadedAllMyClasses) {
      this.showPast = !this.showPast
      // this.content.resize();
    } else {

      this.sessionService.loadBeautyReservations()
        .then((lessons) => {
          this.filtersService.loadedAllMyClasses = true;
          this.showPast = !this.showPast
          // this.content.resize();
        })
        .then(() => {
          if (this.sessionService.beautyReservations.toReview.length > 0) {
            this.app.getRootNav().push(BeautyReviewPage);
          }
        })
        .catch(error => {
          // this.content.resize();

          this.sessionService.reportError(
            'myBeautyClassesPage',
            'seeMoreClasses()',
            error
          );
          let alert = this.alertCtrl.create({
            title: 'Error',
            subTitle: JSON.stringify(error),
            buttons: ['Ok']
          });
          alert.present();
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/beauty/my-beauty-classes/my-beauty-classes.ts